export default function PencilIcon({ size = 14, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" aria-hidden="true">
      <path d="M9.5 2.2 11.8 4.5 5 11.3 2.3 11.7 2.7 9 9.5 2.2Z" fill="none" stroke={color} strokeWidth="1.2" strokeLinejoin="round" />
    </svg>
  );
}
